<template>
    <div class="card" :style="{
        backgroundImage: data.active ? 'linear-gradient(45deg, rgb(24 106 48), rgb(143 217 39))'
            : data.status === 0 && !data.active ? ''
                : data.status === 1 && !data.active ? 'linear-gradient(45deg, rgb(22 49 134), rgb(40 167 164))'
                    : data.status === 2 || data.status === 3 ? 'linear-gradient(45deg, rgb(89 46 7), rgb(235 151 1))' : ''
    }" @click="getClaim">
        <div class="cardTitle">{{ $t('common.travel') }} {{ data.day }}</div>
        <div class="giftImage">
            <img v-if="data.status !== 1" :style="{ opacity: !data.active ? '0.5' : '1' }"
                :class="data.active ? 'chest-animate' : ''" src="@/assets/checkinRewards/closedchest.png" alt="">
            <img v-else src="@/assets/checkinRewards/openchest.png" alt="">
        </div>
        <div class="line"></div>
        <div class="rewardAmount">{{ data.status == 1 || data.status == 2 ? data.amount : amount }}</div>

    </div>
</template>
<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'
const props = defineProps({
    amount: {
        type: Number,
    },
    data: {
        type: Object as any
    }
})
const emits = defineEmits(['getClaim'])
const getClaim = () => {
    if (props.data.active && props.data.status == 0) {
        emits('getClaim')
    }
}
</script>
<style scoped>
.card {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 10px;
    padding: 10px;
    background: #ffffff27;
}

.giftImage img {
    width: 35px;
    height: 25px;
    padding: 10px;
}

.line {
    height: 1px;
    background: #e8e8e82e;
    width: 100%;
}

.rewardAmount {
    font-size: 12px;
    color: yellow;
    padding: 10px 0 0;
}

.chest-animate {
    animation: scaleRotate 1.8s infinite ease-in-out;
    transform-origin: center;
}

@keyframes scaleRotate {
    0% {
        transform: scale(1) rotate(0deg);
    }

    25% {
        transform: scale(1.2) rotate(5deg);
    }

    50% {
        transform: scale(0.95) rotate(-5deg);
    }

    75% {
        transform: scale(1.15) rotate(2deg);
    }

    100% {
        transform: scale(1) rotate(0deg);
    }
}
</style>